<template>
  <div class="ttl-picker">
    <div class="ttl-field">
      <label>Tema</label>
      <select :value="topic" class="ttl-input" :disabled="loading" @change="onTopicChange($event.target.value)">
        <option value="">{{ loading ? 'Cargando temas…' : '— elige el tema —' }}</option>
        <option v-for="item in topics" :key="item.code" :value="item.code">{{ item.label }}</option>
      </select>
    </div>

    <div v-if="selectedTopic" class="ttl-field">
      <label>Línea de negocio</label>
      <select :value="line" class="ttl-input" :disabled="isLineLocked" @change="$emit('update:line', $event.target.value)">
        <option v-if="!isLineLocked" value="">— elige la línea —</option>
        <option v-for="option in selectedTopic.business_lines" :key="option" :value="option">{{ lineLabel(option) }}</option>
      </select>
      <p v-if="lineSpecificLabel" class="ttl-hint">En esta línea el tema se llama «{{ lineSpecificLabel }}».</p>
    </div>
  </div>
</template>

<script>
import { businessLineLabel } from '@/utils/ticketStates';

export default {
  name: 'TicketTopicLinePicker',
  props: {
    topics: { type: Array, default: () => [] },
    topic: { type: String, default: '' },
    line: { type: String, default: '' },
    loading: { type: Boolean, default: false },
  },
  computed: {
    selectedTopic() {
      return this.topics.find((item) => item.code === this.topic) || null;
    },
    isLineLocked() {
      return !!(this.selectedTopic && this.selectedTopic.auto_business_line);
    },
    lineSpecificLabel() {
      if (!this.selectedTopic || !this.line) return '';
      const label = this.selectedTopic.labels_by_line[this.line];
      return label && label !== this.selectedTopic.label ? label : '';
    },
  },
  methods: {
    lineLabel: businessLineLabel,
    onTopicChange(code) {
      const chosen = this.topics.find((item) => item.code === code);
      this.$emit('update:topic', code);
      this.$emit('update:line', chosen && chosen.auto_business_line ? chosen.auto_business_line : '');
    },
  },
};
</script>

<style scoped>
.ttl-picker {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
  margin-bottom: 16px;
}
@media (max-width: 520px) {
  .ttl-picker { grid-template-columns: 1fr; }
}
.ttl-field label {
  font-weight: 600;
  font-size: 12.5px;
  color: #374151;
  margin-bottom: 6px;
  display: block;
}
.ttl-input {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #d9dedb;
  border-radius: 10px;
  font-size: 14px;
  background: #fff;
}
.ttl-input:disabled {
  background: #f4f5f4;
  color: #374151;
  cursor: not-allowed;
}
.ttl-hint {
  margin: 6px 0 0;
  font-size: 12px;
  color: #6b7280;
}
</style>
